// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sec-box {
  cursor: pointer;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  gap: 5px;
}
.sec-box .name {
  height: 45px;
  line-height: 1;
  font-size: 15px;
}

.slider-container {
  position: relative;
  padding: 0 25px;
}

.prev-slide, .next-slide {
  position: absolute;
  top: calc(50% - 12px);
  z-index: 1000;
  font-size: 24px;
  background: none;
  cursor: pointer;
}

.prev-slide {
  right: 0px;
}

.next-slide {
  left: 0px;
}`, "",{"version":3,"sources":["webpack://./src/core/pages/section/components/sections-grid-slider/sections-grid-slider.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,QAAA;AACF;AACE;EACE,YAAA;EACA,cAAA;EACA,eAAA;AACJ;;AAIA;EACE,kBAAA;EACA,eAAA;AADF;;AAIA;EACE,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AADF;;AAIA;EACE,UAAA;AADF;;AAIA;EACE,SAAA;AADF","sourcesContent":[".sec-box {\n  cursor: pointer;\n  width: 100%;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 10px;\n  gap: 5px;\n\n  .name {\n    height: 45px;\n    line-height: 1;\n    font-size: 15px;\n  }\n\n}\n\n.slider-container {\n  position: relative;\n  padding: 0 25px;\n}\n\n.prev-slide, .next-slide {\n  position: absolute;\n  top: calc(50% - 12px);\n  z-index: 1000;\n  font-size: 24px;\n  background: none;\n  cursor: pointer;\n}\n\n.prev-slide {\n  right: 0px;\n}\n\n.next-slide {\n  left: 0px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
